import React, { useRef, useState } from 'react'

import { useSnackbar } from 'notistack'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import ArrowForward from '@mui/icons-material/ArrowForward'

import api from '../../services/api'
import { SectionProps } from '../../types/form'


const Section8 = (props: SectionProps) => {

    const {
        handleNext,
        values,
        files,
        setFiles,
        setIsRejected,
        setRejectReason,
    } = props
    const fileRef = useRef<HTMLInputElement>(null)

    /**
     * FILE UPLOAD
     */
    const handleAddFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) {
            return
        }
        setFiles([...files, ...Array.from(e.target.files)])
    }

    const handleFileRemove = (index: number) => {
        setFiles(files.filter((file, i) => i !== index))
    }

    /**
     * SUBMIT FORM
     */
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false)

    const handleSubmit = () => {
        setLoading(true)
        api.post(
            'v0/recruitment/enrollments/register/',
            Object.fromEntries(Object.entries({
                ...values,
                birth_date: values.birth_date?.format('YYYY-MM-DD'),
                cpf: values['cpf'].replace(/\D/g, ''),
                phone1: values['phone1'].replace(/\D/g, ''),
                phone2: values['phone2'].replace(/\D/g, ''),
                experiences: values['experiences'].map((experience: any) => Object.fromEntries(Object.entries({
                    ...experience,
                    start_date: experience['start_date'].format('YYYY-MM-DD'),
                    end_date: experience['end_date'] ? experience['end_date'].format('YYYY-MM-DD') : null,
                }).filter(([_, v]) => v !== ''))),
                ex_employee_start_date: values.ex_employee_start_date?.format('YYYY-MM-DD') ?? null,
                ex_employee_end_date: values.ex_employee_end_date?.format('YYYY-MM-DD') ?? null,
            }).filter(([_, v]) => v !== '')),
        ).then(res => {
            let formData = new FormData()
            files.forEach(file => formData.append('files', file))
            api.post(
                `v0/recruitment/enrollments/register/${res.data.id}/files/`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } },
            ).then(() => {
                enqueueSnackbar('Cadastro enviado com sucesso', { variant: 'success' })
                handleNext()
                setIsRejected(res.data.classification.status === 'REJECTED')
            })
        }).catch((e) => {
            if (e?.response?.data?.rejection_reasons?.length) {
                setIsRejected(true)
                setRejectReason(
                    e.response.data.rejection_reasons[0].id,
                )
                handleNext()
            } else {
                enqueueSnackbar('Erro ao enviar cadastro', { variant: 'error' })
            }
            setLoading(false)
        })
    }

    /**
     * RENDER COMPONENT
     */
    return (
        <Box>
            <Typography variant={'h2'}>
                Anexos
            </Typography>
            <Typography variant={'body1'} sx={{ mb: '20px' }}>
                Por favor envie uma cópia das páginas de sua carteira de
                trabalho onde constam os três últimos registros profissionais.
            </Typography>

            <Stack
                spacing={3}
                direction={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                border={'4px dashed #95a5a6'}
                padding={'40px'}
            >
                <Typography
                    variant={'h2'}
                    align={'center'}
                    sx={{ color: '#666' }}
                    children={'Selecione suas imagens'}
                />
                <Button
                    variant={'contained'}
                    onClick={() => fileRef.current && fileRef.current.click()}
                    sx={{ backgroundColor: '#2c3e50' }}
                    children={'buscar arquivos'}
                />
                <input
                    ref={fileRef}
                    type={'file'}
                    accept={'image/*'}
                    style={{ display: 'none' }}
                    multiple={true}
                    onChange={handleAddFiles}
                />
            </Stack>

            <Stack
                spacing={3}
                direction={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                mt={5}
            >
                {files.map((file, index) => (
                    <Box key={`${file.name}-${index}`} width={'90%'}>
                        <Box
                            component={'img'}
                            key={index}
                            src={URL.createObjectURL(file)}
                            width={'100%'}
                            height={'auto'}
                        />
                        <Typography
                            sx={{
                                cursor: 'pointer',
                                textAlign: 'center',
                            }}
                            onClick={() => handleFileRemove(index)}
                            children={'remover'}
                        />
                    </Box>
                ))}
            </Stack>

            <Stack direction={'row'} justifyContent={'end'} mt={5}>
                <Button
                    variant={'contained'}
                    onClick={handleSubmit}
                    disabled={loading}
                    endIcon={
                        loading ?
                            <CircularProgress size={20} /> :
                            <ArrowForward fontSize={'small'} />
                    }
                    children={'Próximo'}
                />
            </Stack>
        </Box>
    )
}

export default Section8
